import { useGameStore } from "../state/useGameStore";

export function HeapNav() {
  const phase = useGameStore((s) => s.phase);
  const toggleHeap = useGameStore((s) => s.toggleHeap);
  const clickCount = useGameStore((s) => s.clickCount);

  if (phase === "intro") return null;

  const inHeap = phase === "heap";
  const canInspect = inHeap || clickCount > 0;

  return (
    <nav className="heap-nav" aria-label="Heap view">
      <button
        type="button"
        className={`cta cta--ghost ${inHeap ? "is-active" : ""}`}
        onClick={toggleHeap}
        disabled={!canInspect}
      >
        <span className="cta__label">
          {inHeap ? "Return" : "Your Heap"}
        </span>
        <span className="cta__arrow" aria-hidden="true">
          {inHeap ? "↑" : "↓"}
        </span>
      </button>
    </nav>
  );
}
